/*!
 * s3-url-encode - Because s3 urls are annoying
 */

const encodings: any = {
	"+": "%2B",
	"!": "%21",
	'"': "%22",
	"#": "%23",
	$: "%24",
	// "%": "%25",
	"&": "%26",
	"'": "%27",
	"(": "%28",
	")": "%29",
	"*": "%2A",
	",": "%2C",
	":": "%3A",
	";": "%3B",
	"=": "%3D",
	"?": "%3F",
	"@": "%40",
};

export function encodeFileName(filename: string) {
	return encodeURI(filename).replace(
		/(\+|!|"|#|\$|&|'|\(|\)|\*|\+|,|:|;|=|\?|@)/gim,
		function (match: any) {
			return encodings[match];
		}
	);
}
